import { render } from "./MergeConfirmation.vue?vue&type=template&id=0697165c&scoped=true"
import script from "./MergeConfirmation.vue?vue&type=script&lang=js"
export * from "./MergeConfirmation.vue?vue&type=script&lang=js"

import "./MergeConfirmation.vue?vue&type=style&index=0&id=0697165c&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0697165c"]])

export default __exports__